// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createPaypalCheckoutInstance = (client: unknown): Promise<any> =>
  new Promise((resolve, reject) => {
    if (!window.braintree?.paypalCheckout)
      reject('createPaypalCheckoutInstance: Braintree PayPal checkout SDK is not loaded.');

    window.braintree.paypalCheckout.create(
      { client },
      (error: Error | undefined, instance: unknown) =>
        error
          ? reject(new Error(`Error creating Braintree Paypal checkout: ${error}`))
          : resolve(instance)
    );
  });
